import { render, staticRenderFns } from "./PageWorkoutProgram.vue?vue&type=template&id=6a7991a5"
import script from "./PageWorkoutProgram.vue?vue&type=script&lang=js"
export * from "./PageWorkoutProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports